import { Component, OnInit } from '@angular/core';
import { ValidationError, FormValidator, ErrorHandlingService, FormValidationService } from 'core-lib';
import { ActivatedRoute } from '@angular/router';
import { PermitService } from '../services/permit.service';

@Component({
  selector: 'cli-validate-email',
  templateUrl: './validate-email.component.html',
  styleUrls: ['./validate-email.component.css']
})
export class ValidateEmailComponent implements OnInit {

  isLoading: boolean;
  message: string;
  isError: boolean;
  response: any;

  constructor(private route: ActivatedRoute,
    private permitService: PermitService) {
  }

  ngOnInit() {
    this.message = '';
    this.isError = false;
    let id: string = this.route.snapshot.paramMap.get('id');
    this.isLoading = true;
    this.permitService.validateEmail(id).subscribe(
      res => {
        this.response = res;
        this.isLoading = false;
      },
      err => {
        console.log('HTTP Error', err);
        this.isError = true;
        this.isLoading = false;
      },
      () => {
        console.log('HTTP request completed.');
        this.isLoading = false;
      }

      );

  }
}
